import { gql } from 'graphql-request'

export const FIND_BOOK_COLLECTION_DETAIL = gql`
  query FindBookCollectionDetail($id: Int!, $page: Int!, $limitPerPage: Int!) {
    findBookCollectionDetail(id: $id) {
      id
      collectionName
      description
      privacyType
      user {
        id
        avatarImgPath
        username
        displayName
        profilePageSlug
      }
      likeCount
      isLiked
      facebookShareImageUrl
      twitterShareImageUrl
      bookList(limitPerPage: $limitPerPage, page: $page) {
        data {
          id
          title
          isEnded
          isEbook
          isBanned
          deletedAt
          status
          writer
          penName {
            firstPenName
            user {
              writer {
                affiliation
                status
              }
              displayName
              profilePageSlug
            }
          }
          tags {
            name
          }
          category {
            id
            name
          }
          hasSalePromotions
          buyAllChaptersPromotion {
            startDate
            endDate
            discountType
            discountPercentage
          }
          readFreePromotion {
            startedAt
            endedAt
          }
          bookBadges {
            badgeCategoryId
            badgeImageUrl
          }
          coverImgPath
          cover
          bookType
          likeCount
          isLiked
          commentCount
          viewCount
          isTranslated
          newChapter {
            id
            chapterName
          }
          publishedChapterCount
        }
        page
        total
      }
    }
  }
`
